
// accordion dropdown
function accordion(e) {
    e.classList.toggle("active");
    var panel = e.nextElementSibling;
    if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
    } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
    }
}

var filterItems = document.querySelectorAll('.js-accordion_label');

for (let i = 0; i < filterItems.length; i++) {
    filterItems[i].addEventListener("click", function () {
        var filterItem = new accordion(this);
    })
}



